import { hasLocalStorageAccess } from "@novel/shared/utils/localStorageUtils";
import { parseCookiesToObj } from "@novel/shared/utils/cookieUtils";
const RETRY_INTERVAL_MS = 30;
let cachedCheckoutIdPromise = null;
export async function pollHeadlessCheckoutIdAndOrCartId(onDelayed) {
    if (cachedCheckoutIdPromise) {
        return cachedCheckoutIdPromise;
    }
    cachedCheckoutIdPromise = new Promise((resolve, reject) => {
        let attemptCount = 0;
        const firstTryValue = getHeadlessCheckoutIdAndCartId();
        if (firstTryValue) {
            return resolve(firstTryValue);
        }
        const intervalId = setInterval(() => {
            if (++attemptCount === 2) {
                if (onDelayed) {
                    onDelayed();
                }
            }
            try {
                const result = getHeadlessCheckoutIdAndCartId();
                if (result) {
                    clearInterval(intervalId);
                    return resolve(result);
                }
            }
            catch (e) {
                clearInterval(intervalId);
                reject(e);
            }
        }, RETRY_INTERVAL_MS);
    });
    return cachedCheckoutIdPromise;
}
// all storefront IDs are base64 encoded versions of GIDs
export function getHeadlessCheckoutIdAndCartId() {
    const cookieObj = parseCookiesToObj(document.cookie);
    const cookieObjKeys = Object.keys(cookieObj);
    const ids = {};
    for (let i = 0; i < cookieObjKeys.length; i++) {
        const cookieObjKey = cookieObjKeys[i];
        const matchingValue = cookieObj[cookieObjKey];
        if (matchingValue) {
            const parsedCheckoutId = parseCheckoutIdFromString(decodeURIComponent(matchingValue));
            if (parsedCheckoutId) {
                ids.checkoutId = parsedCheckoutId;
            }
            else {
                const parsedCartId = parseCartIdFromString(matchingValue);
                if (parsedCartId) {
                    ids.cartId = matchingValue;
                }
            }
        }
    }
    if (hasLocalStorageAccess()) {
        const localStorageObj = window.localStorage;
        const localStorageObjKeys = Object.keys(localStorageObj);
        for (let i = 0; i < localStorageObjKeys.length; i++) {
            const localStorageObjKey = localStorageObjKeys[i];
            const matchingValue = localStorageObj[localStorageObjKey];
            if (matchingValue) {
                const parsedCheckoutId = parseCheckoutIdFromString(matchingValue);
                if (parsedCheckoutId) {
                    ids.checkoutId = parsedCheckoutId;
                }
                else {
                    const parsedCartId = parseCartIdFromString(matchingValue);
                    if (parsedCartId) {
                        ids.cartId = matchingValue;
                    }
                }
            }
        }
    }
    if (ids.checkoutId || ids.cartId) {
        return ids;
    }
    return null;
}
const checkoutIdRegex = /(Z2lkOi8vc2hvcGlmeS9DaGVja291dC8[A-Za-z0-9+/=]+)(?:$|[^A-Za-z0-9+/=])/;
function parseCheckoutIdFromString(str) {
    const resolvedStr = str || "";
    // can be undefined, pulled from local storage
    let result = resolvedStr.match(checkoutIdRegex);
    if (result === null || result === void 0 ? void 0 : result[1]) {
        return result[1];
    }
    else {
        result = resolvedStr.match(/^gid:\/\/shopify\/Checkout\//);
        if (result) {
            return btoa(resolvedStr);
        }
    }
    return null;
}
const cartIdRegex = /(Z2lkOi8vc2hvcGlmeS9DYXJ0L[A-Za-z0-9+/=]+)/;
function parseCartIdFromString(str) {
    let result = str.match(/^gid:\/\/shopify\/Cart\//);
    if (result) {
        return str;
    }
    else {
        result = str.match(cartIdRegex);
        if (result === null || result === void 0 ? void 0 : result[1]) {
            return atob(result[1]);
        }
    }
    return null;
}
